import { CloseButton } from "@/components/CloseButton/CloseButton";
import { SearchInput } from "@/components/SearchInput/SearchInput";
import { UIButton } from "@/components/UIButton/UIButton";
import { toggleModal } from "@/core/reatom/state/modal/modal";
import { profGroupAtom } from "@/core/reatom/state/profGroups/";
import {
  selectedCategoriesAtom,
  toggleCategoryAction,
  toggleProfessionsIdAction,
} from "@/core/reatom/state/search/";
import { useAction, useAtom } from "@reatom/npm-react";
import { Icon24CheckCircleOn } from "@vkontakte/icons";
import clsx from "clsx";
import { useState } from "react";
import s from "./style.module.scss";

interface CategoriesProps {
  closeModal: () => void;
}

export const Categories = ({ closeModal }: CategoriesProps) => {
  const [search, setSearch] = useState("");

  const [profGroups] = useAtom(profGroupAtom);
  const [selectedCategory] = useAtom(selectedCategoriesAtom);

  const handleToggleModal = useAction(toggleModal);
  const toggleCategory = useAction(toggleCategoryAction);

  const searchedCategories = profGroups?.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );
  const toggleProfessionIds = useAction(toggleProfessionsIdAction);

  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <p className={s.title}>Категории</p>
      <div className={s.input}>
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          reset={() => setSearch("")}
        />
      </div>
      <div className={s.categories}>
        {searchedCategories &&
          searchedCategories.map((item) => (
            <CurrentCategories
              key={item.id}
              name={item.name}
              id={item.id}
              onClick={() => {
                toggleCategory(item);
                toggleProfessionIds();
              }}
              selected={
                !!selectedCategory?.length &&
                selectedCategory.some((cat) => cat.id === item.id)
              }
            />
          ))}
      </div>

      <UIButton
        onClick={() => handleToggleModal("subCategories")}
        fontType={"primary-2"}
        className={s.submit}
        disabled={!selectedCategory}
      >
        Применить
      </UIButton>
    </div>
  );
};

interface CurrentCategoriesProps {
  name: string;
  id: number;
  onClick: () => void;
  selected: boolean;
}

const CurrentCategories = (props: CurrentCategoriesProps) => {
  const { name, onClick, selected } = props;
  return (
    <div className={s.category} onClick={onClick}>
      <p className={clsx(s.name, selected && s.selected)}>{name}</p>
      {selected && (
        <div className={s.icon}>
          <Icon24CheckCircleOn />
        </div>
      )}
    </div>
  );
};
